import Vue from 'vue';
import SchemaCreateView from "./SchemaCreateView ";
import SchemaEditView from "./SchemaEditView";
export function openSchemaEditModal(options) {
  let resolve;
  const promise = new Promise(r => resolve = r);
  const instance = new Vue({
    methods: {
      onMsg(data) {
        resolve(data);
        this.$destroy();
      }
    },
    render() {
      const h = arguments[0];
      return h(SchemaEditView, {
        "attrs": {
          "options": options
        },
        "on": {
          "msg": this.onMsg
        }
      });
    }
  });
  const el = document.createElement('div');
  document.body.appendChild(el);
  instance.$mount(el);
  return promise;
}
export function openSchemaCreateModal(options) {
  let resolve;
  const promise = new Promise(r => resolve = r);
  const instance = new Vue({
    methods: {
      onMsg(data) {
        resolve(data);
        this.$destroy();
      }
    },
    render() {
      const h = arguments[0];
      return h(SchemaCreateView, {
        "attrs": {
          "options": options
        },
        "on": {
          "msg": this.onMsg
        }
      });
    }
  });
  const el = document.createElement('div');
  document.body.appendChild(el);
  instance.$mount(el);
  return promise;
}
//# sourceMappingURL=index.js.map
